// Deployment configuration - injected at build time
export const DEPLOYMENT_CONFIG = {
  type: 'singleapp-private',
  defaultApp: 'marketing',
  apiUrl: 'https://lofjd518h8.execute-api.us-east-1.amazonaws.com/prod'
};
